import styled from "styled-components";

import {
  DefaultDeleteTableButton,
  DefaultDeleteTableButtonWrapper,
  TableContentWrapper,
} from "@FillInTableContainer/shared/styles/table.style";
import { ScrollTableWrapper } from "@FillInTableContainer/shared/styles/tableScroll.style";

export const TableWrapper = styled(TableContentWrapper)`
  gap: 0;
  background-color: transparent;
`;

export const DeleteTableButtonWrapper = styled(
  DefaultDeleteTableButtonWrapper,
)``;

export const DeleteTableButton = styled(DefaultDeleteTableButton)``;

export const ScrollWrapper = styled(ScrollTableWrapper)``;

export const ScrollContentsWrapper = styled.div`
  width: fit-content;
`;
